module.exports = {
      id: "checkbox-checked-icon-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#checkbox-checked-icon",
      toString: function () {
        return this.url;
      }
    }